export default __webpack_public_path__ + "static/media/Pistol_1.3a0c64ef.png";